import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router";

const Container = styled.div`
  color: #111827;
`;

const WelcomeTitle = styled.h2`
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin: 4px 0 12px;
`;

const Paragraph = styled.p`
  color: #111827;
  font-size: 15px;
  line-height: 1.75;
  margin-bottom: 16px;
  text-align: justify;
`;

const SectionTitle = styled.h2`
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
  margin-top: 24px;
`;

const BulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 15px;
  margin-top: 10px;
`;

const BulletItem = styled.li`
  color: #111827;
  font-size: 15px;
  line-height: 1.65;
  margin-bottom: 10px;
  padding-left: 24px;
  position: relative;
  text-align: justify;

  &:before {
    content: "\\2022";
    color: #183967;
    font-weight: bold;
    position: absolute;
    left: 0;
  }

  strong {
    color: #183967;
    font-weight: 700;
  }
`;

const HighlightBox = styled.div`
  background-color: transparent;
  padding: 0;
  margin: 15px 0;
  border-radius: 4px;
`;

const HighlightTitle = styled.h2`
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
`;

const HighlightText = styled.p`
  color: #111827;
  font-size: 15px;
  line-height: 1.75;
  margin: 0;
  text-align: justify;
`;

const Link = styled(RouterLink)`
  color: #006b8f;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const AboutNmdfcContent = () => {
  return (
    <Container>
      <WelcomeTitle>Welcome to NMDFC</WelcomeTitle>

      <Paragraph>
        The National Minorities Development & Finance Corporation NMDFC was
        incorporated on 30th September 1994, as a company not for profit, under
        Section 25 of the Companies Act 1956 (now Section-8 of Companies
        Act,2013). It is a National Level Apex Body for the benefit of
        Minorities as defined under the National Commission for Minorities Act
        1992.
      </Paragraph>

      <Paragraph>
        The prime mandate of NMDFC is to provide concessional finance to
        the Minorities for self employment/ income generation activities. As per
        the National Commission for Minorities Act, 1992, the notified
        Minorities are Muslims, Christians, Sikhs, Buddhists & Parsis.
        Subsequently, Jain community was also added into the list of notified
        Minority Communities in January 2014. Under NMDFC programe, preference
        is given to Artisans & Women.
      </Paragraph>

      <HighlightBox>
        <HighlightTitle>NMDFC at a Glance</HighlightTitle>
        <HighlightText>
          NMDFC is a Govt. Company under section 8 of Companies Act 2013, under
          the administrative control of Ministry of Minority Affairs, Government
          of India. The Corporation has been set up to promote economic
          development for the benefit of "Backward Sections" amongst the Minority
          Communities i.e. Muslims, Christians, Sikhs, Buddhists, Parsis &
          Jains, preference being given to the occupational group and women.
        </HighlightText>
      </HighlightBox>

      <Paragraph>
        Based on annual income, target group bifurcated into two credit lines as
        follows:
      </Paragraph>

      <BulletList>
        <BulletItem>
          <strong>Credit Line-1:</strong>{" "}
          The benefits are available for persons with annual family income of upto Rs.3.00 lakh.
        </BulletItem>

        <BulletItem>
          <strong>Credit Line-2:</strong>{" "}
          The benefits are available to persons with annual family income of upto Rs. 8.00 lakh.
        </BulletItem>
      </BulletList>

      <Paragraph>
        NMDFC implements its schemes & programs through State Channelizing
        Agencies (SCA list:{" "}
        <Link to="/about/scas-partners">NMDFC State Channelising Agencies (SCAs) and partners</Link>{" "}
        ) nominated by the respective State Governments & Banking Partners.
      </Paragraph>

      <SectionTitle>Achievements at a Glance</SectionTitle>

      <BulletList>
        <BulletItem>
          Since inception, the NMDFC has disbursed an amount of Rs.8008.43 Cr.
          covering over 22.01 lacs families under the schemes of NMDFC.
        </BulletItem>

        <BulletItem>
          Under Micro-Finance scheme, an amount of Rs.3227.77 Cr. has been
          disbursed to over 15.89 lacs families.
        </BulletItem>

        <BulletItem>
          With paid up capital of Rs. 2524 Cr. NMDFC has extended loans worth
          over Rs. 8008.43 cr. which is over three times of its Paid up share
          capital.
        </BulletItem>

        <BulletItem>
          Under the Term Loan scheme, financial assistance of Rs.4780.66 Cr. has
          been given to over 6.11 lacs beneficiaries, spread over twenty-five
          States and five Union Territories. This includes disbursement of Rs.
          422.92 crs. for over 42,583 beneficiaries under Education Loan scheme.
        </BulletItem>
      </BulletList>
    </Container>
  );
};

export default AboutNmdfcContent;
